import { getCwUrl } from '../utils/config';
import { getFetch } from '../utils/fetch';

export const syncGrades = async (courseId) => {
  const baseUrl = `${getCwUrl()}/gateway`;
  const response = await getFetch(`${baseUrl}/course/${courseId}/sync-grades`);
  if (!response.ok) {
    throw new Error(
      `Server request to sync grades failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};

export const jobStatus = async (jobId) => {
  const baseUrl = `${getCwUrl()}/gateway`;
  const response = await getFetch(`${baseUrl}/job/${jobId}`);
  if (!response.ok) {
    throw new Error(
      `Server request to get job status failed.  ${response.status} ${response.statusText}`,
    );
  }
  return response.json();
};
